import * as React from 'react';
export const VASvg = React.forwardRef(function VASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M8 2v12h6.002A2.005 2.005 0 0 0 16 11.991V4.01C16 2.899 15.113 2 14.002 2H8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.887 14 1.998 14H8V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M14 3H8V2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H8v-1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6v1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6v1H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#CFD7DF',
        fillRule: 'nonzero',
        d: 'M13.5 10.165A.5.5 0 1 0 13 9.3a.5.5 0 0 0 .5.866ZM10.933 4.72l2.043 3.538a1.5 1.5 0 1 1-.866.5l-1.543-2.672-.866.5-.5-.866 1.732-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'M10 10.165a.5.5 0 1 0 .5-.866.5.5 0 0 0-.5.866Zm2.567-5.446 1.732 1-.5.866-.866-.5-1.543 2.672a1.5 1.5 0 1 1-.866-.5l2.043-3.538Z',
      }),
    ),
  );
});
VASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var VA = {
  category: 'flag',
  colorable: false,
  name: 'VA',
  svg: VASvg,
};
